export const VickyEvents = {};

VickyEvents.VickyRandom = () => {
  const min = 0;
  const max = 2;
  return Math.floor(Math.random() * (max - min)) + min;
}

VickyEvents.hasActiveEvent = () => {
  return VickyEvents.canStartSecondTalk() ||
      VickyEvents.energyDrinkQuest() ||
      VickyEvents.canStartJoggingEvent() ||
      VickyEvents.canStartBeachEvent() ||
      VickyEvents.canStartTrainingInviteEvent() ||
      VickyEvents.firstMeetingAnastasiaInPub() ||
      VickyEvents.firstTripToHome() ||
      VickyEvents.tournamentTrip() ||
      VickyEvents.parkKiss() ||
      (AnastasiaEvents.disappear() && AnastasiaEvents.disappearExplained)
    ;
}

VickyEvents.displayHint = () => {
  return VickyEvents.canStartSecondTalk() ||
      VickyEvents.canStartJoggingEvent() ||
      VickyEvents.canStartBeachEvent() ||
      VickyEvents.canStartTrainingInviteEvent() ||
      VickyEvents.firstMeetingAnastasiaInPub() ||
      VickyEvents.firstTripToHome() ||
      VickyEvents.tournamentTrip() ||
      VickyEvents.parkKiss() ||
      (AnastasiaEvents.disappear() && AnastasiaEvents.disappearExplained)
    ;
}
VickyEvents.hasActiveQuest = () => {
  return YsServices.questService.status(YsServices.questService.questEnum.EnergyDrink) === 0 && Yosemite.McManager.isInInventory(5);
}

VickyEvents.vickyGenericTalk = () => {
  if(Yosemite.EventStateManager.vickyDailyEventChecked) return true;
  return !VickyEvents.hasActiveEvent() && !VickyEvents.hasActiveQuest();
}

/*
MC: What's new?
Vicky: Not much since the last time we talked. Are you here to work out?
- Yeah, muscles won't build by themselves.
- Sure, if you work out with me.
- No, I came by to see you.
 */
VickyEvents.genericTalk_1 = () => {
  return !Yosemite.EventStateManager.state.gym.vicky.secondTalk;
}

VickyEvents.genericTalk_2 = () => {
  return Yosemite.EventStateManager.state.gym.vicky.secondTalk  && !Yosemite.EventStateManager.state.gym.vicky.jogging;
}

VickyEvents.genericTalk_3 = () => {
  return Yosemite.EventStateManager.state.gym.vicky.jogging &&
    !Yosemite.EventStateManager.state.gym.vicky.training;
}

VickyEvents.genericTalk_4 = () => {
  return Yosemite.EventStateManager.state.gym.vicky.training && !EventStateService.vickyParkKiss;
}

// Waifu state
VickyEvents.genericTalk_5 = () => {
  return EventStateService.vickyParkKiss;
}

VickyEvents.isWaifu = () => {
  return EventStateService.state.waifu.vicky.isWaifu;
}

VickyEvents.canStartSecondTalk = () => {
  // czy już się odbył poprzedni event
  if(!Yosemite.EventStateManager.state.gym.vicky.firstTalk) {
    return false;
  }

  // czy już się odbył ten event
  if(Yosemite.EventStateManager.state.gym.vicky.secondTalk) {
    return false;
  }

  // czy był już dzisiaj jakiś event?
  return !Yosemite.EventStateManager.vickyDailyEventChecked;
}

VickyEvents.energyDrinkQuest = () => {
  // czy już się odbył poprzedni event
  if(!Yosemite.EventStateManager.state.gym.vicky.secondTalk) {
    return false;
  }

  if(YsServices.questService.status(YsServices.questService.questEnum.EnergyDrink) !== YsServices.questService.statusEnum.Active) {
    return false;
  }

  if(YsServices.questService.status(YsServices.questService.questEnum.EnergyDrink) === YsServices.questService.statusEnum.Completed) {
    return false;
  }

  return Yosemite.McManager.isInInventory(5);
}

VickyEvents.canStartJoggingEvent = () => {
  // czy już się odbył
  if(Yosemite.EventStateManager.state.gym.vicky.jogging) {
    return false;
  }

  if(YsServices.questService.status(YsServices.questService.questEnum.EnergyDrink) !== YsServices.questService.statusEnum.Completed) {
    return false;
  }

  // czy jest obecnie aktywna randka z Vicky
  if(Yosemite.EventStateManager.state.bar.vickyFirstDate) {
    return false;
  }

  // czy był już event tego dnia
  if(Yosemite.EventStateManager.vickyDailyEventChecked) {
    return false;
  }

  // na koniec sprawdzamy statystyki
  return Yosemite.McManager.getIntelligence() >= 2;
}

VickyEvents.canStartBeachEvent = () => {
  // czy już się odbył
  if(Yosemite.EventStateManager.state.gym.vicky.beach) {
    return false;
  }

  // czy był już jogging event
  if(!Yosemite.EventStateManager.state.gym.vicky.jogging) {
    return false;
  }

  // czy był już event tego dnia
  if(Yosemite.EventStateManager.vickyDailyEventChecked) {
    return false;
  }

  // na koniec sprawdzamy statystyki
  return Yosemite.McManager.getIntelligence() >= 4;
}

VickyEvents.canStartTrainingInviteEvent = () => {
  // czy już się odbył
  if(Yosemite.EventStateManager.state.gym.vicky.training) {
    return false;
  }

  // czy już się odbył event plaża
  if(!Yosemite.EventStateManager.state.gym.vicky.beach) {
    return false;
  }

  // czy był już event tego dnia
  if(Yosemite.EventStateManager.vickyDailyEventChecked) {
    return false;
  }

  // na koniec sprawdzamy statystyki
  return Yosemite.McManager.getIntelligence() >= 6;
}

VickyEvents.firstMeetingAnastasiaInPub = () => {
  // czy już się odbył wcześniejszy event
  if(!EventStateService.anastasiaMettingVicky) {
    return false;
  }

  // czy był już event tego dnia
  if(EventStateService.vickyDailyEventChecked) {
    return false;
  }

  // czy odbył się wspólny trening z Vicky
  if(!Yosemite.EventStateManager.state.gym.vicky.training) {
    return false;
  }

  // czy już się odbył ten event
  return !EventStateService.vickyFirstMeetingAnastasiaInPub;
}

VickyEvents.firstTripToHome = () => {
  // czy już się odbył wcześniejszy event
  if(!EventStateService.vickyFirstMeetingAnastasiaInPub) {
    return false;
  }

  // czy był już event tego dnia
  if(EventStateService.vickyDailyEventChecked) {
    return false;
  }

  // czy już się odbył ten event
  return !EventStateService.vickyFirstTripToHome;
}

VickyEvents.tournamentTrip = () => {
  // czy już się odbył wcześniejszy event
  if(!EventStateService.vickyFirstTripToHome) {
    return false;
  }

  // czy był już event tego dnia
  if(EventStateService.vickyDailyEventChecked) {
    return false;
  }

  // czy już się odbył ten event
  return !EventStateService.vickyTournamentTrip;
}

VickyEvents.parkKiss = () => {
  // czy już się odbył wcześniejszy event
  if(!EventStateService.vickyTournamentTrip) {
    return false;
  }

  // czy był już event tego dnia
  if(EventStateService.vickyDailyEventChecked) {
    return false;
  }

  // czy już się odbył ten event
  return !EventStateService.vickyParkKiss;
}
